

















import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import {handleClipboard} from "@/util/clipboard";
import RefreshButton from "@/component/Button/refresh-button.vue";
import VueQrcode from 'vue-qrcode';
import ProductActivationApi from "@/module/device/ProductActivationApi";
import ProductUtil from "@/module/device/ProductUtil";
import {TestActiveCode} from "@/module/activation/TestActiveCode";
import productModule from "@/store/module/ProductModule";
import ConfirmDialog from "@/component/Dialog/confirm-dialog.vue";

@Component({
  components: {
    ConfirmDialog,
    RefreshButton,
    VueQrcode,
  }
})
export default class ProductTestActiveCode extends Vue {

  private api = Container.get(ProductActivationApi)

  private get product() {
    return productModule.active
  }

  @Ref()
  private confirmRefreshDialog!: ConfirmDialog

  private testcode = new TestActiveCode()
  private qrcode = ''

  private created() {
    this.qrcode = this.toQrcode('nocode')
    this.getQrcode()
  }

  private async getQrcode() {
    const testcode = this.testcode = await this.api.testcode({
      productId: this.product.id,
    })
    this.qrcode = this.toQrcode(testcode.code)
  }

  private toQrcode(activeCode: string) {
    return ProductUtil.qrcode(this.product.key, this.product.natureKey, activeCode)
  }

  private async refreshQrcode() {
    const testcode = this.testcode = await this.api.refreshTestcode({
      productId: this.product.id,
    })
    this.qrcode = this.toQrcode(testcode.code)
  }

  private copyQrcode(event: MouseEvent) {
    handleClipboard(this.qrcode, event)
  }
}
